import { Text, View, hexColor } from "@lightningtv/solid";
import { Show, createEffect, createSignal } from "solid-js";
import { fontFamily, isRTL, t } from "../../../translations/configuration";

const Subscriptions = (props: any) => {
  const [data, setData] = createSignal(null);

  const W = 1050;

  createEffect(() => {
    const storedData = localStorage.getItem("licenceData");
    if (storedData) {
      try {
        setData(JSON.parse(storedData));
      } catch (error) {
        console.error("Failed to parse storedData:", error);
      }
    }
  });

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  return (
    <View ref={props.ref} x={isRTL() ? 200 : 600} y={150} height={600} width={900} clipping>

      {/* ── Row 1: Package Name (left) + Status (right) ── */}
      <Show when={data()}>
        <View x={0} y={0} width={W}>

          {/* Top row: labels */}
          <View style={{ flexDirection: "row" }}>
            {/* Package Name label */}
            <View width={W / 2}>
              <Text style={{
                fontSize: 25,
                color: hexColor("#6b7280"),
                fontFamily: fontFamily(),
              }}>
                {t("packName") || "Package Name:"}
              </Text>
              {/* Package Name value */}
              <Text y={36} style={{
                fontSize: 28,
                color: hexColor("#f0f6fc"),
                fontFamily: fontFamily(),
                fontWeight: isRTL() ? "normal" : "bold",
              }}>
                {data()?.package_name ?? "—"}
              </Text>
            </View>

            {/* Status label + value */}
            <View x={W / 1.8} width={W / 2}>
              <Text style={{
                fontSize: 25,
                color: hexColor("#6b7280"),
                fontFamily: fontFamily(),
              }}>
                {t('status')}
              </Text>
              {/* Green dot + Active */}
              <View y={36} style={{ flexDirection: "row" }} gap={10}>
                <View
                  y={8} width={12} height={12}
                  borderRadius={6}
                  color={hexColor("#22c55e")}
                />
                <Text x={22} style={{
                  fontSize: 26,
                  color: hexColor("#22c55e"),
                  fontFamily: fontFamily(),
                  fontWeight: isRTL() ? "normal" : "bold",
                }}>
                  {t('active')}
                </Text>
              </View>
            </View>
          </View>

          {/* ── Separator ── */}
          <View y={96} width={W} height={1} color={hexColor("#1e2a3a")} />

          {/* ── Expire Date ── */}
          <Show when={data()?.license_end_date}>
            <View y={116}>
              <Text style={{
                fontSize: 25,
                color: hexColor("#6b7280"),
                fontFamily: fontFamily(),
              }}>
                {t("expireDate") || "Expire Date:"}
              </Text>
              <Text y={36} style={{
                fontSize: 28,
                color: hexColor("#f0f6fc"),
                fontFamily: fontFamily(),
              }}>
                {formatDate(data().license_end_date)}
              </Text>
            </View>
          </Show>

        </View>
      </Show>

      {/* No data fallback */}
      <Show when={!data()}>
        <Text y={40} style={{
          fontSize: 24,
          color: hexColor("#6b7280"),
          fontFamily: fontFamily(),
        }}>
          —
        </Text>
      </Show>

    </View>
  );
};

export default Subscriptions;